import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import EnTranslations from './locales/en/translation.json';
import FrTranslations from './locales/fr/translation.json';
import DeTranslations from './locales/de/translation.json';
import SeTranslations from './locales/se/translation.json';
import FiTranslations from './locales/fi/translation.json';
import NlTranslations from './locales/nl/translation.json';
import DkTranslations from './locales/dk/translation.json';
import NoTranslations from './locales/no/translation.json';
import SpTranslations from './locales/sp/translation.json';

i18n
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "en",
        debug: true,
        resources: {
            en: {
                translation: {
                    ...EnTranslations
                }
            },
            fr: {
                translation: {
                    ...FrTranslations
                }
            },
            de: {
                translation: {
                    ...DeTranslations
                }
            },
            sv: {
                translation: {
                    ...SeTranslations
                }
            },
            fi: {
                translation: {
                    ...FiTranslations
                }
            },
            nl: {
                translation: {
                    ...NlTranslations
                }
            },
            dk: {
                translation: {
                    ...DkTranslations
                }
            },
            no: {
                translation: {
                    ...NoTranslations
                },
            },
            es: {
                translation: {
                    ...SpTranslations
                },
            }

        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
